import DragIcon from 'crono-fe-common/icons/DragIcon';
import Draggable from 'react-draggable';
import { useCronoCallContext } from './CronoCallContext';
import { CronoCallUI } from './CronoCallUI';
import { RecordingDisclaimer } from './RecordingDisclaimer';
import { OpenCallUI } from './OpenCallUI';

export const CronoCallFloatingUI = () => {
  const { callState, cancelRecording, confirmRecording, ...actions } =
    useCronoCallContext();

  const getCurrentState = () => {
    switch (callState.status) {
      case 'connecting':
      case 'reconnecting':
        return (
          <CronoCallUI
            callStatusText={
              callState.status === 'connecting'
                ? 'Connecting...'
                : 'Reconnecting...'
            }
            callState={callState}
            {...actions}
          />
        );
      case 'open':
        return (
          <OpenCallUI
            callStatusText="Connected"
            callState={callState}
            {...actions}
          />
        );
      case 'recordingDisclaimer':
        return (
          <RecordingDisclaimer
            cancelRecording={cancelRecording}
            confirmRecording={confirmRecording}
          />
        );
      case 'closed':
        return null;
      default:
        throw new Error(`Unknown call state: ${callState}`);
    }
  };

  if (callState.status === 'closed') {
    return null;
  }

  return (
    <Draggable bounds="body" handle=".handle">
      <div className="p-4 m-3.5 bg-white border-2 border-neutral-400 rounded-3xl fixed z-[1500] w-90 flex flex-col top-0 left-0">
        <button
          className="handle self-end cursor-grab active:cursor-grabbing bg-transparent border-none p-0 hover:bg-neutral-100 rounded-md h-fit grid place-content-center"
          title="Drag to move"
        >
          <DragIcon />
        </button>
        {getCurrentState()}
      </div>
    </Draggable>
  );
};
